
import React from "react";
import useTheme from "../../../../hooks/useTheme";

import { Card } from "semantic-ui-react"
import { AppColumn, AppRow } from "../../../UI/Layouts";
import AppText from "../../../UI/Texts/AppTexts";
import { SizedBox } from "../../../UI/Sizes";
import { useResponsive } from "../../../UI/ResponsiveContext";
import { formatLocalEventTime, openInNewTab } from "../../../../utils/helperFunctions";
import { AppLinkedText, AppOutlineButton } from "../../../UI/CustomButtons";


const EventDetailSection = ({ eventDetailData }) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();

    const { participantProfiles, eventDetail, when } = eventDetailData;

    const { location } = eventDetail;


    let locationText = eventLocationType(location.type);


    const contactPerson = Object.values(participantProfiles ?? {}).find((profile) => profile.type === 'host')
    const guestPerson = Object.values(participantProfiles ?? {}).find((profile) => profile.type === 'invitee')



    return (<AppColumn>
        <Card fluid style={{
            borderRadius: theme.radius.default,
            padding: isMobile ? theme.spacing.elementPadding : theme.spacing.contentElementPadding,
        }}>
            <AppRow mainAxisAlignment={'space-between'}>
                <AppText.BodyText margins={{ marginBottom: '0px' }} fontWeight={600}>{"Möte"}</AppText.BodyText>

                <AppOutlineButton trailingIcon='calendar alternate outline'
                    onClick={() => {
                        openInNewTab('https://calendar.google.com');
                    }} style={{
                        borderRadius: theme.radius.small,
                    }}>{"Se kalender"}</AppOutlineButton>

            </AppRow>
            <SizedBox height={theme.spacing.elementPaddingSmall} />


            <AppText.Caption>{eventDetail.name}</AppText.Caption>


            <SizedBox height={theme.spacing.elementPaddingSmall} />
            <AppText.Caption>{eventDetail.instructions}</AppText.Caption>
            <SizedBox height={theme.spacing.contentElementPadding} />

            <AppText.Footnote color={theme.colors.grey}>{'Kontaktperson'}</AppText.Footnote>
            <SizedBox height={theme.spacing.elementPaddingSmall} />
            <AppText.Caption >{contactPerson.name}</AppText.Caption>
            <SizedBox height={theme.spacing.elementPaddingSmall} />

            <a href={`mailto:${contactPerson.email}`}>
                <AppLinkedText text={contactPerson.email} />
            </a>
            <SizedBox height={theme.spacing.elementPaddingSmall} />

            <a href={`tel:${contactPerson.phone}`}>
                <AppLinkedText text={contactPerson.phone} />
            </a>

            <SizedBox height={theme.spacing.contentElementPadding} />

            <AppText.Footnote color={theme.colors.grey}>{'Plats'}</AppText.Footnote>
            <AppRow>
                <AppText.Caption>{`${locationText}:`}</AppText.Caption>
                <SizedBox width={theme.spacing.elementPaddingSmall} />
                <a href={location.type === "phone" ? `tel:${location.value}` : location.value}>
                    <AppLinkedText text={location.value} />
                </a>
            </AppRow>

            <SizedBox height={theme.spacing.contentElementPadding} />

            <AppText.Footnote color={theme.colors.grey}>{'Datum och tid'}</AppText.Footnote>
            <SizedBox height={theme.spacing.elementPaddingSmall} />
            <AppText.Caption>{`${formatLocalEventTime(when.startAt, when.endAt)}`}</AppText.Caption>

            {(guestPerson && guestPerson?.comment > 0) && <AppColumn>
                <SizedBox height={theme.spacing.contentElementPadding} />
                <AppText.Footnote color={theme.colors.grey}>{'Kommentar'}</AppText.Footnote>
                <SizedBox height={theme.spacing.elementPaddingSmall} />
                <AppText.Caption>{guestPerson.comment}</AppText.Caption>
            </AppColumn>}
        </Card>

    </AppColumn>)
}



function eventLocationType(type) {
    let locationText = "";

    if (type === "phone") {
        locationText = "Telefonsamtal";
    } else if (type === "conference") {
        locationText = "Webbmöte";
    } else {
        locationText = "Fysiskt möte med adress";
    }

    return locationText;
}


export default EventDetailSection;